/**
 * Display formatters. These are pure functions on data, not design primitives,
 * so they live here rather than in `components/ui.tsx` — somebody looking for
 * "how do we print money" should not have to read a file of React components.
 *
 * Durations are deliberately not here: `formatDuration` in `lib/data/bookings`
 * formats a booking length in minutes, and it belongs beside the booking type
 * it formats.
 */

/** Paise → `₹1,250`. Money is stored as integer minor units everywhere. */
export const formatRupees = (paise: number) => `₹${(paise / 100).toLocaleString('en-IN')}`;
